export const SateliotIcon = ({ ...props }) => (
	<svg
		version="1.1"
		viewBox="0 0 179.72196 151.77777"
		width="179.72195"
		height="151.77777"
		title={'Sateliot'}
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill="#ffffff"
			d="m 122.6984,118.87777 c -7.6,6.3 -15.6,12.1 -23.999999,17.4 H 121.8984 c 4.9,0 9.8,-0.7 14.5,-2.2 4.3,-2 8.2,-4.7 11.6,-8 3.4,-3 6.2,-6.7 8,-10.9 2.1,-4.3 3.1,-9 2.9,-13.8 V 84.677766 c -11.2,12.2 -23.4,23.600004 -36.3,34.100004"
		/>
		<path
			fill="#ffffff"
			d="m 81.298401,109.47777 h -16.7 c -1.7,-0.1 -3.2,-0.9 -4.4,-2.2 -0.9,-1.8 -1.4,-3.8 -1.5,-5.8 V 59.477766 c 0,-2 0.5,-4 1.5,-5.8 1.1,-1.3 2.7,-2 4.4,-2.2 H 121.8984 c 1.5,0 2.2,0.7 3.6,2.2 0.9,1.8 1.4,3.8 1.4,5.8 v 12.3 c 8.1,-7.9 15.4,-16.7 21.8,-26.1 1.5,-1.8 2.7,-3.7 3.6,-5.8 l -4.4,-5.1 c -3.2,-3.3 -7.2,-5.8 -11.6,-7.2 -4.6,-2.1 -9.5,-3.1 -14.5,-2.9 H 64.498401 c -5,-0.2 -10,0.8 -14.5,2.9 -4.5,1.3 -8.5,3.8 -11.6,7.2 -3.7,2.8 -6.4,6.6 -8,10.9 -2.1,4.3 -3.1,9 -2.9,13.8 v 42.000004 c -0.2,4.8 0.8,9.5 2.9,13.8 1.6,4.3 4.3,8.1 8,10.9 0.9,1.3 2.1,2.4 3.6,2.9 l 4.4,-1.5 c 12.3,-4.6 24,-10.7 34.8,-18.1"
		/>
		<path
			fill="#ff6b00"
			d="m 176.1984,6.7777663 c -9.1,-11.4 -32.4,-8.3 -64.1,8.3999997 l -13.899999,7.3 16.299999,-4.2 c 27,-7 39.3,-10.0999997 44,-4.2 4,5 0.5,16.6 -9.3,31 -10.5,15.4 -26.7,32.3 -45.8,47.6 -19.599999,15.800004 -39.899999,28.100004 -57.199999,34.800004 -15.6,6.1 -27.2,6.8 -31.1,1.9 -4.5,-5.7 -3.2,-22.1 8.5,-40.300004 C 1.0984008,115.77777 -5.1015992,133.57777 4.0984008,145.07777 c 3.5,4.4 9.5000002,6.7 17.4000002,6.7 7.9,0 5,-0.2 7.8,-0.6 22.4,-3.5 54.1,-20.3 84.899999,-45 22.5,-18.100004 41.4,-38.100004 53.2,-56.200004 12.5,-19.2 15.6,-34.6 8.8,-43.1999997"
		/>
	</svg>
)
